//Copyright © Northstar Travel Media, LLC. All Rights Reserved - code may not be reused in whole or in part without written consent- removal of this section consitutes a copyright violation

// **************   Omeda Social & Disqus Tracking Start ********************************************************
function OmedaActivity(type) {
    DynaProxy.invoke("SendOmedaActivity", { 'Type': type, 'URL': window.location.href }, function (data) {
        return data
    }, AjaxFailed);
    return false;
}

// **************   Omeda Social & Disqus Tracking End ********************************************************


function appndURL(u,a){if (u.indexOf('?')==-1){u = u + '?'}else{u = u + '&'};u = u + a;return u}
function numberWithCommas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
//do this to get referer on window.location calls
function winloc(u) { window.location = u }
function showError(error) { var stackTrace = error.get_stackTrace(); var message = error.get_message(); var statusCode = error.get_statusCode(); var exceptionType = error.get_exceptionType(); var timedout = error.get_timedOut(); console.log("-" + message + "-"); if (message == "error 0") { return; } alert(message); }

 function serviceProxy(serviceUrl) {
     var _I = this;
     this.serviceUrl = serviceUrl;
     this.invoke = function(method, data, callback, error) {
         var json = JSON.stringify(data);
         var url = _I.serviceUrl + method;
         $.ajax({
             url: url,
             data: json,
             type: "POST",
             contentType: "application/json; charset=utf-8",
             dataType: "json",
             success: function(data) {
                 if (data.d) { data = data.d }
                 if (!callback) return; callback(data); return;
             },
             error: function(err) { if (!error) return; error(err); return; }
         });
     }
 }
function AjaxFailed(result) { if (result.status == 0) { return; } alert(result.status + ' ' + result.statusText); }
 DynaProxy = new serviceProxy("/Dyna.asmx/");


// **************  START PAGE TRACKING ********************************************************  
function myTrackPageView(u,r,a){

    if (a == undefined) { a = "" }
    var orgu = u; qs = ""; qs2 = "";
    if (u.indexOf('?') != -1) { qs = u.substring(u.indexOf('?') + 1); qs2 = "?" + qs }
    try { initTracking(); u = s.prop1 + "/AJAX/" + a; } catch (e) { };
    try { pageTracker._trackPageview(u + qs2); } catch (e) { };
    try { s.prop70 = a; s.prop1 = u; s.prop2 = qs; s.t(); } catch (e) { };
//    if (r) { window.setTimeout(rotateads, 1000) }


}
function myTrackEvent(category, action, label, value) {
    try {
        if (ga) { ga('send', 'event', 'Ajax Actions', category, action); }
    } catch (e) { }

}
// **************  END PAGE TRACKING ********************************************************


function binaryArray(num) {
    var arr = new Array();
    var div;
    var mod;
    var n = num;
    var count = 0;
    do {
        mod = n % 2;
        n = parseInt(n / 2);
        arr[count++] = mod;
    } while (n > 0)
    return arr;
}

function isScrolledIntoView(elem) { var docViewTop = $(window).scrollTop(); var docViewBottom = docViewTop + $(window).height(); var elemTop = $(elem).offset().top; var elemBottom = elemTop + $(elem).height(); return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop)); }

function pushLoadMore(url, p) {
    var title = document.title;
    if (p != undefined && p != "" && p != "1") { if (title.indexOf("| Page ") > 0) { title = title.substring(0, title.indexOf("| Page "))  + "| Page " + p; } else { title += " | Page " + p; } }
    var stateObj = { Title: title };
    history.pushState(stateObj, title, url);
    document.title = title;
}

$(function () {
  
    $(document).on("click", ".show-more", function () {
        var req = new Object;
        var e = $(this);
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = e.attr("_n");
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
                
        pushLoadMore(e.attr("href"), e.attr("_n"));

        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".show-more").parents(".col-12")
            $(e).before(data);
            $(e).remove();           
        }, AjaxFailed);        
        return false;
    })

    $(document).on("click", ".v-show-more", function () {
        var req = new Object;
        var e = $(this);
        req.PageKey = e.attr("_p");
        req.WidgetId = e.attr("_wid");
        req.PageNumber = e.attr("_n");
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
        pushLoadMore(e.attr("href"), e.attr("_n"));
        var DTO = { 'req': req }
        DynaProxy.invoke("PageContentList", DTO, function (data) {
            var e = $(".v-show-more")
            $(e).before(data);
            $(e).remove();
        }, AjaxFailed);
        return false;
    })

    //search
    $(document).on("click", ".jq-page-search-btn2",
        function () {            
            doPagedListNav(1, true);
            return false;
        });

	$(document).on("click", ".jq2-page", function () {
    	var req = new Object;
		req.PageKey = $(this).attr("_p")
		req.WidgetId = $(this).attr("_wid")
		req.PageNumber = $(this).attr("_pg")
		if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
		if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
		if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
		if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
		if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
		if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
		if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }
		$(".search-list-results").css({ opacity: 0.3 });
		var DTO = { 'req': req }
		DynaProxy.invoke("PageContentList", DTO, function (data) {
		    $(".search-list-results").html(data).css('opacity', '');
		    if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
		}, AjaxFailed)

		return false;
	})

	function doSearch(pgNum, more) {
	    if (!more) { $(".search-list-results").css({ opacity: 0.3 }); }

	    var req = new Object;
	    req.PageKey = $(".search-list-results").attr("_p")
	    req.WidgetId = $(".search-list-results").attr("_wid")
	    req.PageNumber = pgNum;
	    req.User1 =$(".search-list-term").val(); //term
	    req.User2 = getFacetCheckedList("dest"); //destination 
	    req.User3 = getFacetCheckedList("travtype"); //traveltype
	    req.User4 = getFacetCheckedList("date"); //date
	    req.User5 = (window.location.href.indexOf("&debug=1") > 0 ? "1" : "0")

	    var DTO = { 'req': req }
	    DynaProxy.invoke("PageContentList", DTO, function (data) {
	        if (more) { var e = $(".search-show-more").parent(); $(e).before(data); $(e).remove(); }
	        else {
	            $(".search-list-results").html(data).css('opacity', '');
	            if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
	         }	        
	    }, AjaxFailed)
	
	}

    $(document).on("click", ".search-show-more", function () {
	    doSearch($(this,false).attr("_n"),true);
	    return false;
	})

    $(document).on("click", ".search-page", function () {
	    doSearch($(this).attr("_pg"), false)
	    return false;
	})

    $(document).on("click", ".search-filter-list-item", function () {
	    var parent = $(this).parents(".filter-facet-list")
	    if ($(parent).hasClass("issingle")) {
            if ($(this).prop('checked')) {//uncheck all other boxes
	            var sVal = $(this).attr('value');
	            $(parent).find("*:checkbox:checked").map(function () {if (sVal !=$(this).attr('value')) {$(this).prop('checked', false)}})
	        }
	    }
	    $(parent).parent().click();
	    doSearch(1, false)
	})

	function getFacetCheckedList(id) {
	    var list = $("#filter-list-" + id);
	    var bSingle = $(list).hasClass("issingle")
	    var opts = "";
	    list.find("*:checkbox:checked").map(function () { opts = opts + $(this).val() + ","; if (bSingle) { return opts;}})
	    return opts;
	}

	var sSearchURL = "/Search";
    function doSiteSearch(q) {
        if (q == null || q.toString().length == 0) {
            return;
        }
	    var u = sSearchURL + (q != "" ? "?q=" + q : "");
	    window.location = u;
    }

    $("button.btn-search").click(function () {
        doSiteSearch($(this).parents(".navbar-search").find("input").val());
		return false;
    });    

    $(".navbar-search").find("input").keypress(function (event) {
        if (event.which == 13) {
            doSiteSearch($(this).val());
            event.preventDefault();
        }
    });


});

function closeme() { $.fancybox.close(); }

function Has3rdPartyCookie() { return getCookie(thirdpartycookiename) == "1"; }

function Create3rdPartyCookie() { setCookie(thirdpartycookiename, 1, 3650); }

function IsLoc3rdParty(locVal, isNewsletter) {
    var rc = false;
    if (!Has3rdPartyCookie()) {
        console.log(locVal)
        var isDownload = false;
        if ($('#divType').length > 0) { isDownload = true }
        if (isNewsletter) {
            if (($('#divPlanner').length == 0) & (locVal == "01" || locVal == "02" || locVal == "03" || locVal == "04")) { $(".pnlThirdParty").show(); rc = true }
            else { $(".pnlThirdParty").hide(); }
        }
        else {
            if (locVal == "" || locVal == "111768") { $(".pnlThirdParty").hide(); }
            else {
                if (isDownload) {
                    if ($('#divType').html() == "Editorial") { $(".pnlThirdParty").show(); rc = true; }
                    else { $(".pnlThirdParty").hide(); }
                }
                else {
                    if ($('#divSprType').html() != "SPR" && $('#divSprType').html() != "WBN") {
                        $(".pnlThirdParty").show(); rc = true
                    }
                }
            }
        }
    }
    else {
        if ($(".thirdpartyList.profile").length == 0) //always show in profile 
        { $(".pnlThirdParty").hide(); }
        else { $(".pnlThirdParty").show(); }
    }
    return rc;
}

jQuery(document).ready(function ($) {

    $(document).on('click', '.jq-sort a', function () {
        var bHasClass = $(this).hasClass("active");
        $(".jq-sort").find("a").removeClass("active");
        if (!bHasClass) { $(this).addClass("active"); }
        doPagedListNav(1, true);
        return false;
    });

    $(document).on("click", ".jq-show-more",  function () {
	    doPagedListNav($(this).attr("_n"), false);
	    return false;
	});

    $(".results-page").find('select').change(function () {
        $(".jq-page-search-btn2").click();
      
    });

    $(".results-page").find("input").keypress(function (event) {
	    if (event.which == 13) {
	        
	        $(".jq-page-search-btn2").click();
	       
	        event.preventDefault();
	    }
	});

    $(document).on("click", ".jq-newsletter-btn", function () {
        var elePar = $(this).parents(".jq-Newsletter")
        elePar.find(".error").hide()

        var opts = ""; var type = "newsletter";
        if (elePar.find("*:checkbox").length > 0) {
            elePar.find("*:checkbox:checked").map(function () {
                if ($(this).val() != 'on') {
                    opts = opts + $(this).val() + "|";
                }
            })
            if (opts == '') {
                elePar.find(".error").html("Please select one or more newsletters to subscribe to.").show();
                return false;
            }
        }

        var firstName = elePar.find("#first-name").val();
        if (firstName.trim().length == 0) {
            elePar.find(".error").html("Please enter a first name to continue.").show();
            return false;
        }

        var lastName = elePar.find("#last-name").val();
        if (lastName.trim().length == 0) {
            elePar.find(".error").html("Please enter a last name to continue.").show();
            return false;
        }

        var location = $("#loc option:selected").val();
        if (location.trim().length == 0) {
            elePar.find(".error").html("Please select a country to continue.").show();
            return false;
        }

        var email = elePar.find("#email-address").val();
        if (!validateEmail(email)) {
            elePar.find(".error").html("Please enter a valid email address to continue.").show();
            return false;
        }

        var checkboxChecked = elePar.find('#accept-checkbox').is(":checked");
        if (!checkboxChecked) {
            elePar.find(".error").html("Please accept the Terms & Conditions to continue.").show();
            return false;
        }

        showNewsletterOptin(email, opts, window.location, type, elePar, firstName, lastName, location)

        return false;
    })

	$(".jq-Newsletter").find("input").keypress(function (event) {
		if (event.which == 13) {
		    $(this).closest(".jq-Newsletter").find("button").click();
		    event.preventDefault();
		}
	});

	initFilteredList();
});

function validateEmail(email) { var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\ ".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA -Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; return re.test(email); }


// **************   FILTERED LISTS ********************************************************
function refreshFilteredList(pg, more) {
    if (!more) { $(".filter-list-results").css({ opacity: 0.3 }); }
	var req = new Object;
	req.PageKey = $(".filter-list-results").attr("_p");
	req.WidgetId = $(".filter-list-results").attr("_wid");
	req.PageNumber = pg;
	req.User1 = $('.filter-list').find(".active").attr("_val");
	var DTO = { 'req': req };
	DynaProxy.invoke("PageContentList", DTO, function (data) {
	    if (more) { var e = $(".show-filtered-more").parent(); $(e).before(data); $(e).remove(); }
	    else {
	        $(".filter-list-results").html(data).css('opacity', '');
	        if (!isScrolledIntoView($('#list-top'))) { $(document).scrollTop($('#list-top').offset().top - 120) }
	    }
	}, AjaxFailed);
}

  function initFilteredList() {
    $(".filter-list").find("a").on("click", function () {
        var bHasClass = $(this).parent().hasClass("active")
        $(".filter-list").find("li").removeClass("active");
        if (!bHasClass) { $(this).parent().addClass("active"); }        
        refreshFilteredList(1, false); return false;
    });
    $(document).on("click", ".show-filtered-more", function () { refreshFilteredList($(this).attr("_n"), true); return false; });
}
// **************  END FILTERED LISTS ********************************************************

/*** Reg ***/

function getreturl() { if (typeof returl == "undefined") { return ""; } else { return returl; } }

function doPagedListNav(pgNum, replace) {

    var l = $(".jq2-list")
    $(l).css({ opacity: 0.3 })
    var req = new Object;
    req.PageKey = $(l).attr("_p");
    req.WidgetId = $(l).attr("_wid");
    req.PageNumber = pgNum

    if ($(".results-page").find(".jq-page-search").length > 0) {
        if ($(".results-page").find(".jq-page-search").val() == "") {
            var e = $(".jq2-list");
            $(e).html("<div class='search-page-util row'><div class='search-page-util--count col-8'>You have entered no keyword(s)...</div></div>");
            $(e).css('opacity', '');
            return;

        }
        else {
            req = buildSiteSearch(req)
        }
    } else {
        if ($(this).is("[_u1]")) { req.User1 = $(this).attr("_u1"); }
        if ($(this).is("[_u2]")) { req.User2 = $(this).attr("_u2"); }
        if ($(this).is("[_u3]")) { req.User3 = $(this).attr("_u3"); }
        if ($(this).is("[_u4]")) { req.User4 = $(this).attr("_u4"); }
        if ($(this).is("[_u5]")) { req.User5 = $(this).attr("_u5"); }
        if ($(this).is("[_u6]")) { req.User6 = $(this).attr("_u6"); }
        if ($(this).is("[_ukw]")) { req.TopicKeyword = $(this).attr("_ukw"); }

    }
    var u = "/Search?q=" + encodeURIComponent(req.User1);
    if (pgNum > 1) { u += "&pg=" + pgNum; }
    pushLoadMore(u, pgNum);
    var DTO = { 'req': req }
    DynaProxy.invoke("PageContentList",
        DTO,
        function (data) {
            var e = $(".jq2-list");
            if (replace) {
                $(e).html(data)
                if (!isScrolledIntoView($('#list-top'))) {
                    $(document).scrollTop($('#list-top').offset().top - 70);
                }

                $(e).css('opacity', '');
            } else {
                $(e).css('opacity', '');
                var e = $(".jq-show-more");
                $(e).before(data);
                $(e).remove();
            }

        },
        AjaxFailed);

}

function buildSiteSearch(req) {
    if ($(".results-page").length > 0) {
        req.User1 = $(".results-page").find(".jq-page-search").val();
    }
    req.User2 = getFilterCheckedList("type"); //type
    req.User4 = getFilterCheckedList("auth"); //author    
    req.User3 = getFilterCheckedList("date"); //date    
    req.User5 = getFilterCheckedList("sort");  //sort
   
    req.User6 = (window.location.href.indexOf("&debug=1") > 0 ? "1" : "0");
    return req;
}

function getFilterCheckedList(id) {
    var opts = "";
    opts = $(".selectpicker." + id +" option:selected").val();
    return opts;
}

function isiniframe() { return ((window.location != window.parent.location) ? true : false); }

function LinkToPage(u, e, ret) {

    if (e != undefined && e != "") { u = appndURL(u, "email=" + escape(e)) }
    if (ret == undefined) { ret = "" }
    if (ret == "") { ret = getreturl() }
    if (ret != "") { u = appndURL(u, "returl=" + escape(ret)) }

    window.location.href = u;

}


function showNewsletterOptin(email, opts, source, type, elePar, firstName, lastName, location) {

    var DTO = { 'em': email, 'o': opts, 'ty': type, 'fn': firstName, 'ln': lastName, 'lo': location }
    DynaProxy.invoke("SaveOptin", DTO, function (data) {
        if (data != "x") {
            // Copy values to box and reveal modal
            elePar.find(".jq-Newsletter-thanks").show()
            elePar.find(".jq-Newsletter-input").hide()
        } else {
            elePar.find(".error").html("There was an error saving your newsletter options.  Please contact us for assistance.").show();

        }

    }, AjaxFailed)

}


function hasGA() { return !(typeof _qaq === 'undefined') }
function hasOmni() { return false;}


var sVenueACHotelURL = ''; var sVenueSearchURL = '/Meeting-Event-Venues/Venue-Search'; var sVenueSearchURL2 = '/Meeting-Event-Venues/Search';
$(function () {
    $('.hotel-ac').initAutoSearch({ 'searchType': 'HOT', 'serviceURL': '/AutoComplete.asmx', 'searchURL': sVenueSearchURL2, 'parentSelector': '' });

    $(".hotel-ac button[type='submit']").click(function () {
        var txtVal = $(".hotel-ac input:text").val();
        var u = "";
        if (sVenueACHotelURL != '') { u = sVenueACHotelURL; sVenueACHotelURL = ''; }
        else {
            if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=HOT"; }
            else { u = sVenueSearchURL2 + "?typ=HOT"; }
        }       
        if (u != '') { u = appndVSrchParms(u); winloc(u);}
    });

    $("#find-venue-submit").click(function () {
        var txtVal = $("#venue-keyword").val();
        if (sVenueACHotelURL != '') { u = sVenueACHotelURL; sVenueACHotelURL = ''; }
        else {
            if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=HOT"; }
            else { u = sVenueSearchURL2 + "?typ=HOT"; }
        }          
        if (u != '') { winloc(u); }
    });
})

function appndVSrchParms(u) { return u + "&rm=" + $("#venue-guest-room").val() + "&cls=" + $("#venue-class").val() + "&mspc=" + $("#venue-meeting-space").val() + "&ff=1" + ($('#360-video-search').prop("checked") ? "&tst=1" : ""); }

 var currentACRequest = null;  

jQuery.fn.initAutoSearch = function () {
    if (this.length == 0) { return }
    var args = arguments[0] || {}; var serviceURL = args.serviceURL; var searchURL = args.searchURL; var searchType = args.searchType; var parentselector = args.parentSelector; if (parentselector == "") { parentselector = "body" }

    var cache = {}; var txtbox = this.find("input:text")
    this.find("button[type='submit']").on("click",function (event) { doSearch(event); return false });
    txtbox.on("keydown",function (event) { if (event.keyCode == '13') { doSearch(event); return false } })
				  .autocomplete({
				      source: function (request, response) {

				          var Req = new Object(); Req.Term = request.term; Req.Context = searchType; var DTO = { 'Request': Req }; var json = JSON.stringify(DTO);
				          currentACRequest=$.ajax({
				              url: serviceURL + "/GetCompleteList", dataType: "json", type: "POST", contentType: "application/json; charset=utf-8", data: json,
				                beforeSend : function()    {           
								if(currentACRequest != null) {
									currentACRequest.abort();
									//console.log('abort');
								}
							},
							error: function () { 
														//console.log('ac error term:' + request.term)
								  response("") },
				              success: function (data) {
								//   console.log('ac success term:' + request.term)
				                  if (data.d) { data = data.d; }
				                  var resp = $.map(data, function (item) {
				                      if (item.key == 0) {
				                      }
                            if (item.Type == "X") { return null; }
                            else { return { label: item.Name, value: item.Data, url: item.URL, type: item.Type, src: searchType }; }
				                  });
				                  response(resp)
				              }
				          })
				      },				     
                      appendTo: parentselector, minLength: 3, delay: 0,
				      select: function (event, ui) {
				          if (ui.item.url != null) { var trk = ""; var trkt = "acg"; var c = ui.item.src; if (ui.item.type == "X") { trk = "&" + trkt + "acfm=1"; } trk = trkt + "=1" + trk; onACItemSelected(trk, ui.item.url, c, ui.item.value) }
				          else { return false; }
				      }
				  }).data("ui-autocomplete")._renderItem = function (ul, item) {
				      if (item.url == null) {
                var s = "<img src='/dist/images/ac/" + item.type + ".png?20180708'/>" + item.label
				          return $("<li class='ac-group'>").append(s).appendTo(ul);
				      } else {
				          return $("<li class='ac-item'>").append("<a>" + item.label + "</a>").appendTo(ul);
				      }

				  }

    function doSearch(event) { var txtVal = txtbox.val(); var u = ""; if (sVenueACHotelURL != '') { u = sVenueACHotelURL;  } else { if (txtVal != "") { u = sVenueSearchURL + "?pst=" + escape(txtVal) + "&typ=" + searchType; } else { u = sVenueSearchURL2 + "?typ=" + searchType; } }; if (u != '') { u = appndVSrchParms(u); winloc(u); } return false; }

    function onACItemSelected(t, u, c, v) { if (t != "") { u = appndURL(u, t); } sVenueACHotelURL = u; }

    function suptwinloc() { var b = true; if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) { var ffversion = new Number(RegExp.$1); b = ffversion < 5; } return b; }

    function winloc(u) { if (!suptwinloc()) { window.location = u; return; } var a = document.createElement("a"); if (!a.click) { window.location = u; return; } a.setAttribute("href", u); a.style.display = "none"; document.body.appendChild(a); a.click(); }
};

//sharer
!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.ShareThis = t() }(this, function () {
    "use strict"; function e(e) { var t = e.document.body, n = "static" === e.getComputedStyle(t).position ? t.parentNode : t; return n.getBoundingClientRect() } function t(e, t) { return h || (h = o(e)), e[h](t) } function n(e, n) { for (var r = e; r && (1 !== r.nodeType || !t(r, n)) ;) r = r.parentNode; return r } function r(e, t) { var n = e.compareDocumentPosition(t); return !n || (16 & n) > 0 } function o(e) { for (var t = "atchesSelector", n = ["matches", "m" + t, "webkitM" + t, "mozM" + t, "msM" + t, "oM" + t], r = 0; r < n.length; r++) { var o = n[r]; if (e[o]) return o } } function i(e, t) { for (var n = 0; n < e.length; n++) { var r = e[n]; if (r.name === t) return r } } function a(e, t) { if (t && "object" === ("undefined" == typeof t ? "undefined" : m(t))) for (var n in t) e[n] = t[n]; return e } function c(e) { return "function" == typeof e } function u(e) { if (Array.isArray(e)) { for (var t = 0, n = Array(e.length) ; t < e.length; t++) n[t] = e[t]; return n } return Array.from(e) } function f(e) { if (e.isCollapsed) return !0; var t = e.anchorNode.compareDocumentPosition(e.focusNode); return t ? (4 & t) > 0 : e.anchorOffset < e.focusOffset } function l(e, t) { var n = void 0, r = e.getClientRects(), o = [].slice.bind(r); if (t) { for (var i = 1 / 0, a = r.length; a--;) { var c = r[a]; if (c.left > i) break; i = c.left } n = o(a + 1) } else { for (var f = -(1 / 0), l = 0; l < r.length; l++) { var s = r[l]; if (s.right < f) break; f = s.right } n = o(0, l) } return { top: Math.min.apply(Math, u(n.map(function (e) { return e.top }))), bottom: Math.max.apply(Math, u(n.map(function (e) { return e.bottom }))), left: n[0].left, right: n[n.length - 1].right } } function s(e, t) { var o = e.cloneRange(); if (e.collapsed || !t) return o; var i = n(e.startContainer, t); return i ? r(i, e.endContainer) || o.setEnd(i, i.childNodes.length) : (i = n(e.endContainer, t), i ? o.setStart(i, 0) : o.collapse()), o } function d(t, n, r) { var o = r.document, i = o.defaultView, a = i.getSelection(), c = f(a), u = l(n, c), s = e(i), d = t.style; c ? d.right = o.documentElement.clientWidth - u.right + s.left + "px" : d.left = u.left - s.left + "px", d.width = u.right - u.left + "px", d.height = u.bottom - u.top + "px", d.top = u.top - s.top + "px", d.position = "absolute", t.className = r.popoverClass } function p(e, t) { var r = n(t.target, "[" + g + "]"); if (r) { var o = r.getAttribute(g), a = i(e, o); a && c(a.action) && a.action(t, r) } } function v(e) { return { createPopover: function () { var t = e.createElement("div"); return t.addEventListener("click", function (e) { p(this.sharers, e) }), t }, attachPopover: function (t) { e.body.appendChild(t) }, removePopover: function (e) { var t = e.parentNode; t && t.removeChild(e) } } } var h = void 0, m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, g = "data-share-via", y = function (e, t, n, r) { var o = e.shareUrl || e.document.defaultView.location; return "<ul>" + t.map(function (e) { return '<li data-share-via="' + e.name + '">' + e.render.call(e, n, r, o + (o.toString().indexOf("?") > 0 ? "&" : "?") + "src=" + e.name) + "</li>" }).join("") + "</ul>" }, b = void 0, C = ["selectionchange", "mouseup", "touchend", "touchcancel"], S = function (e) {
        function t(e) { g.addEventListener(e, o) } function n(e) { g.removeEventListener(e, o) } function r() { E && d(E, i(), p) } function o(e) { var t = e.type, n = "selectionchange" === t; !E !== n && setTimeout(function () { var e = i(); e ? u(e) : f() }, 10) } function i() { var e = S.getSelection(), t = e.rangeCount && e.getRangeAt(0); if (t) { var n = s(t, p.selector); if (!n.collapsed && n.getClientRects().length) return n } } function u(e) {
            var t = !E
            , n = e.toString(), r = p.transformer(n), o = p.sharers.filter(l.bind(null, r, n)); return o.length ? (t && (E = M.createPopover()), E.sharers = o, E.innerHTML = y(p, o, r, n), d(E, e, p), void (t && (M.attachPopover(E), c(p.onOpen) && p.onOpen(E, r, n)))) : void (E && f())
        } function f() { E && (M.removePopover(E), E = b, c(p.onClose) && p.onClose()) } function l(e, t, n) { var r = n.active; return c(r) ? r(e, t) : r === b || r } var p = (Object.assign || a)({ document: document, selector: "body", sharers: [], popoverClass: "share-this-popover", transformer: function (e) { return e.trim().replace(/\s+/g, " ") } }, e || {}), h = !1, m = !1, g = b, S = b, E = b, M = b; return { init: function () { return !h && (g = p.document, S = g.defaultView, S.getSelection ? (C.forEach(t), S.addEventListener("resize", r), M = v(g), h = !0) : (console.warn("share-this: Selection API isn't supported"), !1)) }, destroy: function () { return !(!h || m) && (C.forEach(n), S.removeEventListener("resize", r), f(), g = b, S = b, m = !0) } }
    }; return S
});

!function (e, o) { "object" == typeof exports && "undefined" != typeof module ? o(exports) : "function" == typeof define && define.amd ? define(["exports"], o) : o(e.ShareThisViaFacebook = e.ShareThisViaFacebook || {}) }(this, function (e) { "use strict"; function o(e, o, n) { return '<a href="' + this.getShareUrl(e, n) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-facebook"></use></svg></a>' } function n(e, o) { var st = $(".facebook-share").attr("_ShareURL"); if (st != "") { o = st; } return "https://www.facebook.com/sharer/sharer.php?quote=" + encodeURIComponent(e) + "&u=" + encodeURIComponent(o) } function t(e, o) { e.preventDefault(), o.ownerDocument.defaultView.open(o.firstChild.href, "share_via_facebook", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } e.render = o, e.getShareUrl = n, e.action = t, e.name = "facebook", Object.defineProperty(e, "__esModule", { value: !0 }) });

!function (e, n) { "object" == typeof exports && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n(e.ShareThisViaLinkedIn = e.ShareThisViaLinkedIn || {}) }(this, function (e) { "use strict"; function n(e, n, t) { var r = this.getText(e); return '<a href="' + this.getShareUrl(r, t) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-linkedin"></use></svg></a>' } function t(e) { var n = e.trim(); return n.length > i - 2 && (n = n.slice(0, i - 3).trim() + "â€¦"), "â€œ" + n + "â€" } function r(e, n) { var st = $(".linked-in-share").attr("_ShareURL"); if (st != "") { n = st; } return "https://www.linkedin.com/shareArticle?mini=true&summary=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(n) } function o(e, n) { e.preventDefault(), n.ownerDocument.defaultView.open(n.firstChild.href, "share_via_linked_in", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } var i = 250; e.render = n, e.getText = t, e.getShareUrl = r, e.action = o, e.name = "linked-in", Object.defineProperty(e, "__esModule", { value: !0 }) });

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.ShareThisViaTwitter = e.ShareThisViaTwitter || {}) }(this, function (e) { "use strict"; function t(e, t, n) { var r = this.getText(e); return '<a href="' + this.getShareUrl(r, n) + '" target="_blank" rel="noopener nofollow noreferrer"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-twitter"></use></svg></a>' } function n(e) { var t = e.trim(); return t.length > i - 2 && (t = t.slice(0, i - 3).trim() + "â€¦"), "â€œ" + t + "â€" } function r(e, t) { var st = $(".twitter-share").attr("_ShareURL"); if (st != "") { t = st; } return "https://twitter.com/intent/tweet?via=TravelAgeWest&text=" + encodeURIComponent(e) + "&url=" + encodeURIComponent(t) } function o(e, t) { e.preventDefault(), t.ownerDocument.defaultView.open(t.firstChild.href, "share_via_twitter", "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640").opener = null } var i = 120; e.render = t, e.getText = n, e.getShareUrl = r, e.action = o, e.name = "twitter", Object.defineProperty(e, "__esModule", { value: !0 }) });

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};


$(function () {
    // bind to all "social links" so that they open in a dialog
    initSocialShares()
});

function initSocialShares() {
    $(".icn-facebook").on("click", function () {
        OmedaActivity("FaceBook");
        return false;
    });

    $(".icn-twitter").on("click", function () {
        OmedaActivity("Twitter");
        return false;
    });

    $(".icn-pinterest").on("click", function () {
        OmedaActivity("Pinerest");
        return false;
    });

    $(".icn-linkedin").on("click", function () {
        OmedaActivity("Linkedin");
        return false;
    });

    $(".icn-mail").on("click", function () {
        OmedaActivity("Email");
        return true;
    });

    $('a[data-share-dialog]').on('click touch', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        try { gaEvent("Social Sharing", $(this).attr("aria-label"), $(this).attr("_pgk")) } catch (ex) { }
        this.ownerDocument.defaultView.open(
            this.href,
            "share",
            "height=440,location=no,menubar=no,scrollbars=no,status=no,toolbar=no,width=640"
        );
    });
}


function setCookie(cookieName, cookieValue, nDays) {
    var today = new Date(),
        expire = new Date();

    if (nDays === null || nDays === 0) {
        nDays = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * nDays);

    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString();
};

function getCookie(cookieName) {
    var theCookie = " " + document.cookie,
        ind = theCookie.indexOf(" " + cookieName + "=");

    if (ind === -1) { ind = theCookie.indexOf(";" + cookieName + "="); }
    if (ind === -1 || cookieName === "") { return ""; }

    var ind1 = theCookie.indexOf(";", ind + 1);

    if (ind1 === -1) { ind1 = theCookie.length; }

    return unescape(theCookie.substring(ind + cookieName.length + 2, ind1));
};

